import { applyFiletransferUpdate } from 'console/redux/devices/items/actions';
import { selectDevices, selectNullableSelectedDeviceId } from 'entities/device/lib';
export const open_upgrade_dialog = () => ({ type: 'OPEN_UPGRADE_DIALOG' });
export const close_upgrade_dialog = () => ({ type: 'CLOSE_UPGRADE_DIALOG' });
export const open_message_action = (content) => ({ type: 'OPEN_MESSAGE', content });
export const close_message_action = () => ({ type: 'CLOSE_MESSAGE' });
export const open_message_beta_action = () => ({ type: 'OPEN_MESSAGE_BETA' });
export const close_message_beta_action = () => ({ type: 'CLOSE_MESSAGE_BETA' });
export const close_z3k_action = () => ({
    type: 'CLOSE_Z3K_SETTINGS',
});
export const unclose_z3k_action = () => ({
    type: 'UNCLOSE_Z3K_SETTINGS',
});
export const open_message_downgrade_action = () => ({ type: 'OPEN_MESSAGE_DOWNGRADE' });
export const close_message_downgrade_action = () => ({ type: 'CLOSE_MESSAGE_DOWNGRADE' });
export const upgrade_message_action = (beta, downgrade) => ({ type: 'UPGRADE_MESSAGE', beta, downgrade });
export const firmware_releases_action = (releases, changelogs) => ({ type: 'FIRMWARE_RELEASES', releases, changelogs });
export const release_action = (release, not_upgrade_beta, not_upgrade_downgrade) => ({
    type: 'SELECT_RELEASE',
    release,
    not_upgrade_beta,
    not_upgrade_downgrade,
});
export const select_file_action = (file) => ({ type: 'SELECT_FILE', file });
export const not_reboot_device_action = () => ({ type: 'NOT_REBOOT' });
export const set_slow_mode_action = (slow_mode) => ({ type: 'SLOW_MODE', slow_mode });
export const is_loading_action = (is_loading) => ({ type: 'IS_LOADING', is_loading });
export const is_loading_upload_action = (is_loading) => ({ type: 'IS_LOADING_UPLOAD', is_loading });
export const is_loading_firmware_action = (is_loading) => ({ type: 'FIRMWARE_RELEASES_LOADING', is_loading });
export const file_upload_action = (files) => ({ type: 'SELECT_FILE_UPLOAD', files });
export const prefix_action = (prefix) => ({ type: 'PREFIX', prefix });
export const remove_file_action = (fileName) => ({ type: 'REMOVE_FILE', fileName });
export const select_release_action = (release) => (dispatch, getState) => {
    const not_upgrade_beta = release.beta;
    const current_id = selectNullableSelectedDeviceId(getState());
    const current_version = selectDevices(getState()).find((device) => device.id == current_id)?.firmware_version?.[0];
    const not_upgrade_downgrade = current_version != null && current_version > release.firmware_version;
    dispatch(release_action(release, not_upgrade_beta, not_upgrade_downgrade));
};
export const fetch_get_releases_action = (id) => async (dispatch, getState, { api }) => {
    dispatch(is_loading_firmware_action(true));
    try {
        const { firmwares, changelogs } = await api.get_firmware_releases(id);
        if (!getState().upgrade_soft.select_release && firmwares.length > 0) {
            dispatch(select_release_action(firmwares[0]));
        }
        dispatch(firmware_releases_action(firmwares, changelogs));
    }
    catch (error) {
        const { json } = error;
        dispatch(open_message_action({
            title: 'Не удалось загрузить список прошивок',
            message: json?.error_ui ?? 'Не удалось загрузить список прошивок',
        }));
    }
    finally {
        dispatch(is_loading_firmware_action(false));
    }
};
export const upgrade_official_firmware_action = (device_id) => async (dispatch, getState) => {
    const selectRelease = getState().upgrade_soft.select_release;
    if (selectRelease == null) {
        return;
    }
    if (selectRelease.not_upgrade_beta) {
        dispatch(open_message_beta_action());
    }
    else if (selectRelease.not_upgrade_downgrade) {
        dispatch(open_message_downgrade_action());
    }
    else {
        dispatch(upgrade_firmware_action(device_id));
        dispatch(select_release_action(selectRelease.release));
        dispatch(close_z3k_action());
    }
};
export const upgrade_firmware_action = (device_id) => async (dispatch, getState, { api }) => {
    const selectRelease = getState().upgrade_soft.select_release;
    if (device_id == null) {
        return;
    }
    if (!selectRelease) {
        return;
    }
    try {
        const response = await api.upgrade_firmware(device_id, selectRelease.release.id, getState().upgrade_soft.slow_mode);
        dispatch(close_upgrade_dialog());
        for (const transfer of response.transfers) {
            dispatch(applyFiletransferUpdate(device_id, transfer));
        }
    }
    catch (error) {
        const { json } = error;
        dispatch(open_message_action({
            title: 'Ошибка при обновлении ПО',
            message: json?.error_ui ?? 'Не удалось отправить запрос на сервер',
        }));
    }
};
export const fetch_manual_upgrade_firmware_action = () => async (dispatch, getState, { api }) => {
    const device_id = selectNullableSelectedDeviceId(getState());
    if (device_id == null)
        return;
    if (!FormData) {
        dispatch(open_message_action({
            title: 'Неподдерживаемый браузер',
            message: 'Загрузка прошивок из файлов не поддерживается в вашем браузере. Воспользуйтесь Chrome, Firefox, Opera 12+ или Internet Explorer 10+',
        }));
        return;
    }
    const manualUpgradeState = getState().upgrade_soft.manual_upgrade;
    const files = [];
    if (manualUpgradeState.firmware)
        files.push({
            code: 'firmware',
            file: manualUpgradeState.firmware,
            filename: manualUpgradeState.firmware.name,
        });
    if (manualUpgradeState.profile)
        files.push({
            code: 'profile',
            file: manualUpgradeState.profile,
            filename: manualUpgradeState.profile.name,
        });
    try {
        dispatch(is_loading_action(true));
        const response = await api.upgrade_firmware_custom(device_id, manualUpgradeState.not_reboot, files, getState().upgrade_soft.slow_mode);
        dispatch(close_upgrade_dialog());
        dispatch(applyFiletransferUpdate(device_id, response.transfer));
    }
    catch (error) {
        const { json } = error;
        dispatch(open_message_action({
            title: 'Загрузка файлов не удалась',
            message: json?.error_ui ?? 'Ошибка связи с сервером',
        }));
    }
    finally {
        dispatch(is_loading_action(false));
        dispatch(select_file_action({ file: null, name: 'firmware' }));
        dispatch(select_file_action({ file: null, name: 'profile' }));
    }
};
export const fetch_upload_action = () => async (dispatch, getState, { api }) => {
    const device_id = selectNullableSelectedDeviceId(getState());
    if (device_id == null)
        return;
    if (!FormData) {
        dispatch(open_message_action({
            title: 'Неподдерживаемый браузер',
            message: 'Загрузка прошивок из файлов не поддерживается в вашем браузере. Воспользуйтесь Chrome, Firefox, Opera 12+ или Internet Explorer 10+',
        }));
        return;
    }
    try {
        dispatch(is_loading_upload_action(true));
        const response = await api.upload_files(device_id, true, getState().upgrade_soft.upload.prefix, getState().upgrade_soft.upload.files, getState().upgrade_soft.slow_mode);
        dispatch(close_upgrade_dialog());
        dispatch(applyFiletransferUpdate(device_id, response.transfer));
    }
    catch (error) {
        const { json } = error;
        dispatch(open_message_action({
            title: 'Загрузка файлов не удалась',
            message: json?.error_ui ?? 'Ошибка связи с сервером',
        }));
    }
    finally {
        dispatch(is_loading_upload_action(false));
        dispatch(file_upload_action([]));
        dispatch(prefix_action(''));
    }
};
